import Formsy from "formsy-react";
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from "react-accessible-accordion";
import acceptImg from "../../../webroot/images/acceptImg.svg"
import rejectImg from "../../../webroot/images/rejectImg.svg"
import FormsyInputField from "../../elements/FormsyInputField";
import FormsyDatePicker from "../../elements/FormsyDatePicker";
import dateFormat from "dateformat";
import FormsyTextAreaAutosize from "../../elements/FormsyTextAreaAutosize";
import { useMemo } from "react";

const SoftApprovalCreditInvestigation = ({ props, setAllowSubmit, softApprovalData, current_page_fields, handleInputChange, isLeadHistoryExists, form_read_only, current_page, maxTime, handleRadioChange, softApprovalDocs, markAsFreezed, handleFileChange, allowSubmit, accessCondition, isDocRequired, isDataChanged, saveFormDetails, leadDetail, navigate, params, showModalViewTimeLine, remarksHistory, updatestatus }) => {
    const now = new Date();
    const { isCreditInvestigationPage, saveDisabled, nextDisabled, showSaveButton, showNextButton, handleNextClick } = useMemo(() => {
        const isCIPage = current_page === "credit_investigation_recieved";
        const isFrozen = form_read_only || !allowSubmit || markAsFreezed || accessCondition;
        const isLeadStatus28 = leadDetail?.lead_status_history?.some(ls => ls.sub_status_id === 28);
    
        // Save logic
        const saveCondition = isCIPage
            ? isFrozen || isLeadStatus28 || !isDataChanged
            : isFrozen || isDocRequired || !isDataChanged;
        const saveDisabled = !!saveCondition;
        const showSaveButton = !saveCondition;
    
        // Next logic
        const hasSoftApprovalYes = softApprovalData?.some(sf => sf?.org_is_credit_investigation_received === "yes");
        const nextCondition = isCIPage
            ? isFrozen || isLeadStatus28 || !hasSoftApprovalYes
            : !isLeadHistoryExists || isFrozen || isLeadStatus28;
        const nextDisabled = !!nextCondition;
        const showNextButton = !nextCondition;
    
        const handleNextClick = isCIPage
            ? updatestatus
            : () => navigate(`/lead-detail/credit-investigation/${params.lead_id}`);
    
        return { isCreditInvestigationPage: isCIPage, saveDisabled, nextDisabled, showSaveButton, showNextButton, handleNextClick };
    }, [current_page, form_read_only, allowSubmit, markAsFreezed, accessCondition, isDocRequired, isDataChanged, leadDetail, isLeadHistoryExists, softApprovalData, navigate, params.lead_id, updatestatus]);
    return (<div className={"switch-toggle"}>
        <div className="lead-form-heading">
            {props.current_page === "credit_investigation_recieved" && <h2>Credit Investigation</h2>}
            <h2>{props.name}</h2>
        </div>
        <Formsy
            className="lead-form-filed soft-approval-filled-outer"
            autoComplete="off"
            onValid={() => setAllowSubmit(true)}
            onInvalid={() => setAllowSubmit(false)}
        >
            {softApprovalData?.map((tab) =>

                <Accordion allowZeroExpanded>
                    <div className="">
                        <AccordionItem className='acc-item-financer'>
                            <AccordionItemHeading className='acc-heading-financer'>
                                <AccordionItemButton>
                                    <div className='financer-name-no-date financer-name-date financer-name-no-date'>
                                        <img alt='' src={props.current_page === "soft_approval" ? (tab['is_soft_approval_received'] === "yes" ? acceptImg : tab['is_soft_approval_received'] === "no" ? rejectImg : "") : (tab['is_credit_investigation_received'] === "yes" ? acceptImg : tab['is_credit_investigation_received'] === "no" ? rejectImg : "")} className="check-uncheck-img" />
                                        <h3 title={tab.financier_name}>  {tab.financier_name}</h3>
                                        {tab.org_custom_soft_approval_received && <span className='date-time-txt'>{dateFormat(tab.org_custom_soft_approval_received, 'd mmm,yyyy, h:MM:ss TT')}</span>}

                                        {tab.credit_investigation_recieved_date && <span className='date-time-txt'>{dateFormat(tab.credit_investigation_recieved_date, 'd mmm,yyyy, h:MM:ss TT')}</span>}
                                    </div>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel className='acc-panel-finaner'>
                                <div className="soft-approvel-sec">
                                    <div className="row">
                                        {current_page_fields.map((field) => (
                                            ["text", "pattern-format"].includes(field.type) ? (
                                                <fieldset className="form-filed col-md-12 ">
                                                    <div className="material">

                                                        <FormsyInputField
                                                            id={field.id}
                                                            name={field.name}
                                                            type={field.type}
                                                            value={tab && tab[field.name]}
                                                            placeholder=" "
                                                            label={field.label}
                                                            onChange={e => handleInputChange(field.name, field.type, e, tab.financier_id)}
                                                            format={field.ApplyNumberformat ? field.format : ""}
                                                            required={field.required}
                                                            readOnly={tab.org_is_soft_approval_received || field.readOnly || (tab.org_is_soft_approval_received === "yes" && isLeadHistoryExists) || form_read_only}
                                                            col={"col-md-12"}
                                                            disabled={!tab.is_soft_approval_received} />
                                                    </div>
                                                </fieldset>
                                            ) :
                                                field.type === "date-picker" && ((current_page === "credit_investigation_recieved" && tab['is_credit_investigation_received'] === "yes") || current_page === "soft_approval") ? (
                                                    <fieldset className="form-filed col-md-12">
                                                        <div className="material date-filed">
                                                            <FormsyDatePicker
                                                                name={field.name}
                                                                selectedDate={tab && tab[field.name] && new Date(tab[field.name])}
                                                                value={(tab?.[field.name] && Date.parse(tab[field.name])) || ''}
                                                                placeholder={field.label}
                                                                maxDate={new Date()}
                                                                onDateSelect={(e) => !form_read_only ? handleInputChange(field.name, field.type, e, tab.financier_id) : e.preventDefault()}
                                                                dateFormat="dd MMM, yyyy h:mm aa"
                                                                showTimeSelect={true}
                                                                minTime={now.setHours(0, 0, 0)}
                                                                maxTime={maxTime}
                                                                validations={field.validations}
                                                                validationError={current_page_fields[field.name] ? field.validationError : ""}
                                                                required={field.name === "custom_soft_approval_received_date" && tab.is_soft_approval_received === "yes" ? true : field.required}
                                                                hasError={(current_page_fields.hasOwnProperty(field.name) && !current_page_fields[field.name]) ? true : false}
                                                                readOnly={field.readOnly || form_read_only || (field.name !== "custom_soft_approval_received_date" && tab.org_is_credit_investigation_received) || (tab.org_is_soft_approval_received === "yes" && isLeadHistoryExists) || tab.org_is_soft_approval_received}
                                                                onBlur={(e) => console.log(e)}
                                                                col={"col-md-12"}
                                                                disabled={field.name === "custom_soft_approval_received_date" && !tab.is_soft_approval_received} />
                                                        </div>
                                                    </fieldset>
                                                ) :
                                                    field.type === "textarea" ? (
                                                        <fieldset className="form-filed text-area-filed col-md-12">
                                                            <div className="material">
                                                                <FormsyTextAreaAutosize
                                                                    name={field.name}
                                                                    value={(tab && tab[field.name]) || ""}
                                                                    placeholder=" "
                                                                    label={field.label}
                                                                    onChange={e => handleInputChange(field.name, field.type, e, tab.financier_id)}
                                                                    format={field.ApplyNumberformat ? field.format : ""}
                                                                    required={current_page === "credit_investigation_recieved" ? (field.name === "ci_reference_notes" && tab.is_credit_investigation_received === "no" ? true : field.required) : (field.name === "soft_approval_reference_notes" && tab.is_soft_approval_received === "no" ? true : field.required)}
                                                                    readOnly={(tab.org_is_soft_approval_received || field.readOnly || form_read_only || tab.org_is_soft_approval_received === "yes") && isLeadHistoryExists}
                                                                    disabled={current_page === "credit_investigation_recieved" ? tab?.credit_investigation_recieved_date && tab?.new_texarea !== 1 : false ||
                                                                        !tab.is_soft_approval_received} />
                                                                <label data-label={(field.name === "soft_approval_reference_notes" && tab.is_soft_approval_received === "no" ? `${field.label}*` : field.label)} className="form-label"></label>
                                                            </div>
                                                        </fieldset>
                                                    ) :
                                                        field.type === 'radio' ? (
                                                            <>
                                                                <fieldset className="form-filed col-md-12 radio-btn radio-type-txt">
                                                                    <label className="form-label">{field.label}</label>
                                                                    {field.options.map((option, key) => (
                                                                        <div className="custom-control custom-checkbox" key={option.value}>
                                                                            <input
                                                                                aria-label={`for ${option.label}`}
                                                                                type="radio"
                                                                                className="custom-control-input"
                                                                                name={`${option.name}${tab.financier_id}`}
                                                                                value={option.value}
                                                                                checked={tab[`${field.name}`]?.toString() === option.value}
                                                                                onChange={(e) => handleRadioChange(field.name, e, tab.financier_id)}
                                                                                disabled={tab.org_is_soft_approval_received || (tab.org_is_soft_approval_received === "yes" && isLeadHistoryExists && props.current_page === "soft_approval") || (form_read_only && props.current_page === "soft_approval")}
                                                                                required={current_page === "credit_investigation_recieved"} />
                                                                            <label htmlFor={option.id} className="custom-control-label">{option.label}</label>
                                                                        </div>
                                                                    ))}
                                                                </fieldset>
                                                            </>
                                                        ) : null
                                        ))}
                                    </div>
                                    {current_page !== "credit_investigation_recieved" && (DocumentUploadHandler(softApprovalDocs, tab, form_read_only, markAsFreezed, handleFileChange))}
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>

                    </div>
                </Accordion>)}
            
            <div className="btn-save-remarks">
                {showSaveButton ? <button type="submit" className="btn-primary" disabled={saveDisabled} onClick={saveFormDetails}>Save</button> : <span className="span-disabled">Save</span>}
                {showNextButton ? <button type="submit" className={isCreditInvestigationPage ? "btn-line" : "btn-primary"} disabled={nextDisabled} onClick={handleNextClick}>Next</button> : <span className="span-disabled">Next</span>}
                <button type="button" className="btn-line" onClick={showModalViewTimeLine}>Remarks <span className="m-xs-l">({remarksHistory?.length || 0})</span></button>
            </div>
        </Formsy>
    </div>);
};

export default SoftApprovalCreditInvestigation;

function DocumentUploadHandler(softApprovalDocs, tab, form_read_only, markAsFreezed, handleFileChange) {
    return <>
        <div className="lead-form-heading">
            <h3><b>Documents Upload</b></h3>
        </div>
        <div className="acco-doc-list">
            <ul>
                {softApprovalDocs
                    .filter(doc => doc.financier_id === tab.financier_id)
                    .map((doc) => {
                        const isMaxReached = doc.lead_doc_count === doc.max_upload;
                        const isUploadDisabled = isMaxReached ||
                            form_read_only ||
                            markAsFreezed ||
                            tab.org_is_soft_approval_received === "yes" ||
                            tab.org_is_soft_approval_received;

                        const isUploadRequired = doc.is_required === "1" &&
                            !(doc.lead_doc_count >= doc.min_upload) &&
                            tab.is_soft_approval_received === "yes";

                        return (
                            <li key={doc.id}>
                                <div className='doc-count-txt'>
                                    {isMaxReached && <span className="stepprogress"><i className="sprite ic-check" /></span>}
                                    {doc.doclang?.name}
                                    {doc.is_required === "1" && tab.is_soft_approval_received === "yes" ? '*' : ''}
                                    <span className="lead-doc-count">{doc.lead_doc_count || 0} / {doc.max_upload}</span>
                                </div>

                                <div className="more-file-upload doc-upload-btn">
                                    {isUploadDisabled ? (
                                        <button type="button" className="btn-line" disabled>
                                            <i className='ic-upload'></i> Upload
                                        </button>
                                    ) : (
                                        <>
                                            <input
                                                aria-label="img upload"
                                                type="file"
                                                accept=".pdf,image/*"
                                                disabled={isMaxReached || !tab.is_soft_approval_received}
                                                required={isUploadRequired}
                                                onChange={e => handleFileChange(
                                                    e,
                                                    doc.id,
                                                    doc.parent_id,
                                                    doc.max_upload,
                                                    doc.lead_doc_count,
                                                    tab.financier_id
                                                )} />
                                            <button type="button" className="btn-line">
                                                <i className='ic-upload'></i> Upload
                                            </button>
                                        </>
                                    )}
                                </div>
                            </li>
                        );
                    })}
            </ul>
        </div>
    </>;
}
